import React from "react";
import { Link } from "react-router-dom";
import {
  Shield, TrendingUp, Coins, LineChart, Heart, HandHeart,
  Stethoscope, ClipboardList, Activity, Home as HomeIcon,
  GraduationCap, Briefcase, Users, Banknote, BadgePercent, Crown, ArrowUpRight,
} from "lucide-react";

const ICON_MAP = {
  "term-life": Shield,
  "whole-life": Heart,
  "disability-income": Activity,
  "mortgage-protection": HomeIcon,
  "ltc": HandHeart,
  "health-marketplace": ClipboardList,
  "iul-accumulation": LineChart,
  "529-college": GraduationCap,
  "annuity-accumulation": TrendingUp,
  "exec-bonus-162": BadgePercent,
  "annuity-income": Coins,
  "medicare": Stethoscope,
  "iul-protection": Banknote,
  "premium-financed-iul": Crown,
  "key-person": Briefcase,
  "buy-sell": Users,
  "estate-ilit": Crown,
};

export const PRODUCT_ICON_MAP = ICON_MAP;

export const ProductCard = ({ product, variant = "primary" }) => {
  const Icon = ICON_MAP[product.id] || Shield;
  const isSecondary = variant === "secondary";
  const isComingSoon = product.is_available === false;

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className={`lw-card group p-6 sm:p-7 flex flex-col h-full ${
        isSecondary ? "bg-lw-ivory-warm" : ""
      }`}
    >
      <div className="flex items-start justify-between mb-5">
        <div
          className="w-11 h-11 rounded-xl flex items-center justify-center"
          style={{
            background:
              "linear-gradient(135deg, rgba(11,37,69,0.06) 0%, rgba(212,162,76,0.12) 100%)",
            color: "#0B2545",
          }}
          aria-hidden="true"
        >
          <Icon size={20} />
        </div>
        <div className="flex flex-col items-end gap-1.5">
          <span className="lw-pill">
            Ages {product.age_range_min}–{product.age_range_max}
          </span>
          {isComingSoon && (
            <span
              data-testid={`coming-soon-pill-${product.id}`}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-lw-navy text-lw-ivory text-[10px] font-semibold uppercase tracking-[0.14em]"
            >
              {product.availability_status || "Coming Soon"}
            </span>
          )}
        </div>
      </div>

      <h3 className="font-serif-display text-xl sm:text-[1.35rem] leading-snug text-lw-navy">
        {product.name}
      </h3>
      <p className="mt-2 text-sm text-lw-muted leading-relaxed">
        {product.tagline}
      </p>

      <ul className="mt-5 space-y-2 flex-1">
        {(product.features || []).slice(0, 4).map((f) => (
          <li
            key={f}
            className="flex items-start gap-2 text-sm text-lw-navy/80"
          >
            <span
              aria-hidden="true"
              className="mt-2 h-1 w-1 rounded-full bg-lw-gold flex-shrink-0"
            />
            {f}
          </li>
        ))}
      </ul>

      <Link
        to={`/products/${product.id}`}
        data-testid={`product-cta-${product.id}`}
        className="mt-6 inline-flex items-center gap-1.5 font-sans-ui text-sm font-semibold text-lw-navy group-hover:text-[#8a6a2b] transition-colors"
      >
        Learn more
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </Link>
    </article>
  );
};

export default ProductCard;
